export default function languageToggle() {
	const $langToggles = $('.LanguageToggle-select');

	$langToggles
		.change(function () {
			const $select = $(this);
			const $selectedOption = $select.find(':selected');
			const langCode = $selectedOption.data('langCode');

			const $list = $select.next();
			const url = $list.find(`a[data-lang-code=${langCode}]`).attr('href');

			if ($select.data('track-interactions')) {
				const context = $select.data('tealium-context');
				window.location.href =
					url +
					`?_s_sit=action|change language - ${context}|${$select
						.find('option:selected')
						.text()}&c=t`
						.split(' ')
						.join('_');
			} else {
				// MTC-1185, add querystring parameters to the language url
				let originalUrl = window.location.href;
				let urlParams = originalUrl.includes('?') ? originalUrl.split('?')[1] : '';
				window.location.href = urlParams ? url + '?' + urlParams : url;
			}
		})
		.each(function () {
			$(this).val($(this).find('option[selected]').val());
		});
}
